<template>
    <div class="dynamic-list">
        <section class="list-input">
            <el-select class="item" v-model="selectValue" placeholder="全部状态">
                <el-option
                    v-for="item in identity"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
            </el-select>
            <el-date-picker class="item" v-model="param.date" type="daterange" align="right" unlink-panels
                            range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                            :picker-options="pickerOptions2">
            </el-date-picker>
            <el-input  class="item" style="width: 240px" v-model="name" placeholder="输入发布人"></el-input>
            <el-button class="item" type="primary" @click="search()" plain>搜索</el-button>
        </section>

        <section>
            <el-table :data="dynamicListData" >

                <el-table-column label="序号" align="center">
                    <template slot-scope="scope">
                        {{ (scope.$index + 1 ) + ((apiData.page - 1) * 10) }}
                    </template>
                </el-table-column>

                <el-table-column label="昵称" align="left" width="200">
                <template slot-scope="scope">
                    <div class="table-title">

                        <template v-if="scope.row.customerlogo">
                            <img class="headerimg" :src="scope.row.customerlogo" alt="img">
                        </template>
                        <template v-else>
                            <img class="headerimg" src="@/common/images/fansmgt/icon_headerimg.png" alt="img">
                        </template>
                        <p>{{scope.row.customername}}</p>
                    </div>
                </template>
            </el-table-column>
                <el-table-column prop="datetime" label="发布时间" align="center" width="180px"></el-table-column>
                <el-table-column label="主题详情" align="center" width="320">
                    <template slot-scope="scope">
                        <p class="details">{{scope.row.content}}</p>
                    </template>
                </el-table-column>
                <el-table-column prop="viewcount" label="浏览量" align="center"></el-table-column>
                <el-table-column prop="commentcount" label="回复量" align="center"></el-table-column>
                <el-table-column prop="praisecount" label="点赞量" align="center"></el-table-column>

                <el-table-column label="状态" align="center">

                    <template slot-scope="scope">

                        <p class="table-status">

                            <template v-if="scope.row.status == 1">
                                <span class="status-1">正常</span>
                            </template>
                            <template v-if="scope.row.status == 11">
                                <span class="status-3">隐藏</span>

                            </template>
                        </p>

                    </template>
                </el-table-column>
                <el-table-column label="操作" align="right" width="140">

                    <template slot-scope="scope">
                        <div class="table-position">

                            <el-button @click="getStarContentDetailList(scope.row.innerid)">详情</el-button>
                            <template v-if="message.status !== 100">
                                <!--<span>|</span>-->
                                <!--<template v-if="scope.row.status == 1">-->
                                    <!--<el-button @click="listStatusPosition(scope.row.innerid, 11)">隐藏主题</el-button>-->
                                <!--</template>-->
                                <!--<template v-if="scope.row.status == 11">-->
                                    <!--<el-button @click="listStatusPosition(scope.row.innerid, 1)">显示主题</el-button>-->
                                <!--</template>-->

                                <span>|</span>
                                <el-button @click="listStatusPosition(scope.row.innerid, 100)">删除</el-button>
                            </template>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </section>
        <!-- end 表单 -->

        <section>
            <el-pagination background layout="prev,pager,next"  @current-change="fPage()" :total="rowCount" align="center" style="margin-top:20px"></el-pagination>
        </section>
        <!-- end 分页 -->

        <template>
            <el-dialog title="主题详情" :visible.sync="imgDialog" width="1200px" top="4vh">

                <div class="dialog-content-list">
                    <div class="dialog-content-item">
                        <div class="header"><img :src="getStarContentDetailData.userlogo" alt="headerimg"></div>
                        <div class="details">

                            <div class="details-title">
                                <p>{{ getStarContentDetailData.username }}</p>
                                <p><span>{{ getStarContentDetailData.datetime }}</span><span>点赞 {{ getStarContentDetailData.praisecount }}</span></p>
                            </div>
                            <!-- 顶部 end -->

                            <div class="details-txt">
                                <p> {{ getStarContentDetailData.content }} </p>
                            </div>
                            <!-- 详情 end -->

                            <div class="details-other-list" v-if="getStarContentDetailData.attachinfo !== ''">

                                <template v-for="item in getStarContentDetailData.attachinfo">

                                    <img class="item-img" v-if="item.atttype == 1" :src="item.attUrl" alt="headerimg">
                                    <!-- 图片 end -->
                                    <p class="item-p" v-if="item.atttype == 2"><a :href="item.attUrl" target="_blank"><i class="el-icon-paperclip"></i>{{ item.attname }}</a></p>
                                    <!-- 文件 end -->
                                </template>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="dialog-content-list">
                    <p class="dialog-list-title">回复的评论数（{{ commentinfo.length }}）</p>
                    <div class="dialog-content-list">

                        <p v-if="commentinfo.length == 0" style="margin-top: 50px;">暂无评论</p>

                        <div class="dialog-content-item" v-for="item in commentinfo" v-else>
                            <div class="header"><img :src="item.userlogo" alt="headerimg"></div>
                            <div class="details">
                                <div class="details-title">
                                    <p>{{item.username}}</p>
                                    <p><span>{{item.datetime}}</span></p>
                                </div>
                                <div class="details-txt">
                                    <p>{{item.content}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </el-dialog>
        </template>
        <!-- 弹窗 详情 end  -->

    </div>
</template>

<script>
import {getStarSubject, updateStarSubjectByStatus, getContentMap, getStarContentDetail} from '@/api/starMgtApi' // 引入星球管理 api 资源文件
import {getCookie} from '@/common/js/tools' // 引入 tools 库
import {mapActions} from 'vuex' // 引入 vuex 组件
import $ from 'jquery' // 引入 jquery 组件

export default {
    name: 'DynamicList',
    props: ['message'],
    data() {
        return {
            token: getCookie('token'), // token
            sessionUser: JSON.parse(sessionStorage['user']), // 用户信息
            loading: false,
            commentinfo: [], //评论
            innerid: this.$route.query.innerid, // 星球编号
            dynamicListData: [], // 主题列表数据
            currenPaget: 1, // 当前页面
            rowCount: 0, // 数据条数
            page: 1, // 页数
            apiData: {page:1}, // 查询/分页 api 数据
            getStarContentDetailData: '', // 列表详细数据
            selectValue: '',
            name: '',
            imgDialog: false,
            param: {
                date: ''
            },
            identity: [
                {
                    value: '',
                    label: '所有状态'
                },
                {
                    value: 1,
                    label: '正常'
                }
            ],
            pickerOptions2: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date()
                            const start = new Date()
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
                            picker.$emit('pick', [start, end])
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date()
                            const start = new Date()
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
                            picker.$emit('pick', [start, end])
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date()
                            const start = new Date()
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
                            picker.$emit('pick', [start, end])
                        }
                    }
                ]
            }
        }
    },
    mounted() {
        // 读取地址链接  获取星球innerid  和  所属页面分类
        let apiData = this.apiData = {
            LoginToken: this.token,
            starinnerid: this.innerid,
            page: 1,
            pageSize: 10
        }
        this.getStarSubjectApi(apiData)
    },
    methods: {
        getStarSubjectApi(data) {
        // 主题列表查询、分页通用接口调用
            getStarSubject({
                data: data,
                success: data => {
                    this.setLoading(false)
                    this.dynamicListData = data.data.content
                    this.rowCount = data.data.pageinfo.rowCount

                },
                error: data => {
                    this.setLoading(false)
                    console.log(data)
                }
            })
        },
        search() {
            // 搜索
            let apiData = this.apiData = {
                LoginToken: this.token,
                starinnerid: this.innerid,
                begintime: this.param.date[0] === undefined ? '' : this.param.date[0],
                endtime: this.param.date[1] === undefined ? '' : this.param.date[1],
                customername: this.name,
                status: this.selectValue,
                page: 1,
                pageSize: 10
            }
            this.setLoading(true)
            this.getStarSubjectApi(apiData)
        },
        listStatusPosition(innerid, status) {
            // 主题列表状态控制 隐藏、显示、删除
            let txt // 文案
            switch (status) {
                case 1:
                    txt = '您确定公开该主题吗？'
                    break
                case 11:
                    txt = '您确定隐藏该主题吗？'
                    break
                case 100:
                    txt = '您确定删除该主题吗？'
                    break
            }

            this.$confirm(txt, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.setLoading(true)
                let data = {
                    LoginToken: this.token,
                    status: status,
                    innerid: innerid
                }
                // 接口连接
                updateStarSubjectByStatus({
                    data: data,
                    success: data => {
                        this.setLoading(false)
                        // 如果是删除则调用新的接口  如果是修改状态则读取缓存文件调整
                        if (status === 100) {
                            this.getStarSubjectApi(this.apiData)
                        } else {
                            for (let i = 0; i < this.dynamicListData.length; i++) {
                                if (this.dynamicListData[i].innerid === innerid) {
                                    this.dynamicListData[i].status = status
                                }
                            }
                        }
                    },
                    error: data => {
                        console.log(data)
                    }
                })
            }).catch(() => {})
        },
        getStarContentDetailList(innerid) {
            let datalist = {
                LoginToken: this.token,
                starinnerid: this.innerid,
                contentid: innerid,
                datatype: 3
            }
            this.setLoading(true)
            getStarContentDetail({
                data: datalist,
                success: data => {
                    this.setLoading(false)
                    this.getStarContentDetailData = data.data
                    this.commentinfo = data.data.commentinfo
                    // if(data.data.attachinfo.length == 0) {
                    //     this.$message.error('暂无主题')
                    // } else {
                        this.imgDialog = true
                    // }
                },
                error: data => {
                    this.setLoading(false)
                }
            })
        },
        fPage() {
            // 分页处理
            this.setLoading(true)
            let clickPage = $('.dynamic-list .el-pagination .active').html()
            this.apiData.page = parseInt(clickPage)
            this.getStarSubjectApi(this.apiData)
        },
        ...mapActions(
            ['setLoading']
        )
    }
}
</script>

<style lang="scss">

    .el-date-editor {
        .el-range-separator {
            line-height: 27px
        }
    }



    .headerimg {
        border-radius: 50%;
    }
    .el-table {
        min-height: 490px;

        .details {
            display: -webkit-box;
            max-height: 92px;
            -webkit-line-clamp: 4;
            line-clamp: 4;
            -webkit-box-orient: vertical;
            -moz-box-orient: vertical;
            -ms-box-orient: vertical;
            box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        .el-table__empty-block {
            width: 100% !important;
            background-position: center;
            background-size: 40%;
            height: 420px;
        }
    }
    .details-other-list .item-p a {
        font-size: 16px;
        color: #409EFF;
    }
    .el-dialog {
        min-height: 400px;
    }
</style>
